import { Controller, type Control } from "react-hook-form";
import Radio from "@/components/Radio";
import type { CreateTestPersonFormValues, CreateTestPersonPatStatus } from "./types";

const PAT_STATUS_OPTIONS: { value: CreateTestPersonPatStatus; label: string }[] = [
  {
    value: "QUALIFYING",
    label: "Qualifying score (handicap)"
  },
  {
    value: "PASSED",
    label: "Passed (tour exemption)"
  },
  {
    value: "NONE",
    label: "None"
  }
];

type PatSectionProps = {
  control: Control<CreateTestPersonFormValues>;
};

export default function PatSection({ control }: PatSectionProps) {
  return (
    <div data-testid="create-test-person-pat-section">
      <div className="text-title-medium mb-1">PAT status</div>
      <p className="text-body-small text-sys-brand-on-surface-variant mb-4">
        Defaults follow program type (passed for active associate/member and terminated associate; none for suspended
        associate/member and terminated member; qualifying for prospect/student/affiliate). Override to provision a
        qualifying handicap score or a passed tour exemption without creating events.
      </p>
      <Controller
        control={control}
        name="patStatus"
        render={({ field }) => (
          <div className="flex flex-col gap-4" role="radiogroup" aria-label="PAT status">
            {PAT_STATUS_OPTIONS.map((option) => (
              <Radio
                key={option.value}
                name="patStatus"
                id={`patStatus-${option.value}`}
                label={option.label}
                checked={field.value === option.value}
                onChange={() => field.onChange(option.value)}
              />
            ))}
          </div>
        )}
      />
    </div>
  );
}
